export type Token =
  | { kind: 'text'; value: string }
  | { kind: 'bold'; value: string }
  | { kind: 'link'; label: string; href: string }
  | { kind: 'field'; key: string };

const TOKEN_REGEX = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\)|\{\{[a-zA-Z]+\}\})/g;

export function parse(input: string): Token[] {
  if (!input) return [];
  const tokens: Token[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  TOKEN_REGEX.lastIndex = 0;
  while ((match = TOKEN_REGEX.exec(input)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({ kind: 'text', value: input.slice(lastIndex, match.index) });
    }
    const m = match[0];
    if (m.startsWith('**')) {
      tokens.push({ kind: 'bold', value: m.slice(2, -2) });
    } else if (m.startsWith('[')) {
      const linkMatch = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(m);
      if (linkMatch) {
        tokens.push({ kind: 'link', label: linkMatch[1], href: linkMatch[2] });
      } else {
        tokens.push({ kind: 'text', value: m });
      }
    } else if (m.startsWith('{{')) {
      tokens.push({ kind: 'field', key: m.slice(2, -2) });
    }
    lastIndex = match.index + m.length;
  }
  if (lastIndex < input.length) {
    tokens.push({ kind: 'text', value: input.slice(lastIndex) });
  }
  return tokens;
}

export function substituteFields(
  tokens: Token[],
  values: Record<string, string>,
): Token[] {
  return tokens.map(t => {
    if (t.kind !== 'field') return t;
    const value = values[t.key];
    if (value === undefined) return t;
    return { kind: 'text', value };
  });
}

export function toPlainText(tokens: Token[]): string {
  return tokens
    .map(t => {
      if (t.kind === 'text' || t.kind === 'bold') return t.value;
      if (t.kind === 'link') return t.label;
      if (t.kind === 'field') return `{{${t.key}}}`;
      return '';
    })
    .join('');
}
